<template>
  <div class="footer">
    <language-switcher :color="'#fff'" />

    <div class="footer__logout-wrp">
      <!--eslint-disable-->
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        class="footer__svg"
      >
        <path
          d="M12.875 15.25V17.625C12.875 18.2549 12.6665 18.859 12.2953 19.3044C11.9242 19.7498 11.4207 20 10.8958 20H2.97917C2.45426 20 1.95085 19.7498 1.57968 19.3044C1.20852 18.859 1 18.2549 1 17.625V3.375C1 2.74511 1.20852 2.14102 1.57968 1.69562C1.95085 1.25022 2.45426 1 2.97917 1H10.5C11.593 1 12.875 2.06341 12.875 3.375V5.75M16.0417 15.25L20 10.5L16.0417 5.75M6.54167 10.5H19.2083"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <!--eslint-enable-->
      <button class="footer__logout" @click="logout">
        {{ $t('side-bar.footer.logout') }}
      </button>
    </div>
  </div>
</template>

<script>
import FormMixins from '@/Vue/mixins/form.mixins';
import LanguageSwitcher from '@/Vue/common/LanguageSwitcher';
import { useStore } from 'vuex';

export default {
  components: {
    LanguageSwitcher,
  },
  mixins: [FormMixins],
  setup() {
    const store = useStore();
    const logout = async () => {
      await store.dispatch('logout');
      location.reload();
    };
    return { logout };
  },
};
</script>

<style lang="scss" scoped>
@import '../../../scss/variables';
@import '../../../scss/mixins';

.footer {
  padding: 0 0 3rem 2rem;
  display: flex;
  height: 6rem;
  align-items: center;
  gap: 2rem;
  @include respond-to($tablet) {
    padding: 0;
  }

  &__svg {
    @include respond-to($tablet) {
      max-width: 1.5rem;
      max-height: 1.5rem;
    }
  }

  &__logout {
    font-weight: 400;
    font-size: 1.6rem;
    color: $col-primary;
    padding-left: 0.7rem;
    @include respond-to($tablet) {
      font-size: 1rem;
      padding: 0 0 0 0.4rem;
    }
    &-wrp {
      display: flex;
    }
  }
}
</style>
